import React from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import Heading from "../ui/Heading";
import { Link } from "react-router-dom/cjs/react-router-dom";
import {  Je_welryspelling } from "../../../../../Helpers/request";
import customeDesignImg from '../../../../../Assets/nokaoi-imges/custom-ring.jpg'

const CustomDesign = () => {
  return (
    <section className="custom-design">
      <Container className="showcase-container" >
        <Row className="align-items-center">
          <Col md={6} xs={12} className="text-center">
            <Image src={customeDesignImg} className="img-fluid" alt="Custom Design Jewelry " />
          </Col>

          <Col md={6} xs={12}>
            <Heading className="text-left w-100">
              <h2 className="" tyle={{ color: '#333' }}>How to Design a Custom Engagement Ring</h2>
              <span style={{ color: '#333' }} className="">Banded Together Forever</span>
              {/* <p>
                Indulge in the luxury of self-expression with our custom design {Je_welryspelling}  service. From intricate details to personalized  touches, each piece is crafted to reflect your unique style and story. Elevate your look with bespoke treasures that are asexceptional as you are.
              </p> */}
            </Heading>

            <div className="text-sm-center text-lg-left text-md-center text-center">
              <Link to="/custom-design" className="btn outline-base-btn large text-transform-capitalize ">
                 Get Inspired
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default CustomDesign;
